<script>
  import { createEventDispatcher, onMount } from 'svelte';
  const dispatch = createEventDispatcher();
  export let label;
  export let name;
  export let iconType;
  export let value = '';
  export let error;
  export let type = 'text';
  export let placeholder = '';
  export let parentClass;
  export let labelColor;
  export let inputStyle;
  export let disabled;
  export let maxLength;
  export let isRequired = false;
  export let autocomplete;
  let formInput;
  export let autoFocus = false;

  export const focusOnInput = () => {
    formInput.focus();
  };

  onMount(() => {
    if (autoFocus) {
      focusOnInput();
    }
  });

  const iconList = {
    email: '/images/email.svg',
    password: '/images/lock.svg',
    otp: '/images/otp-icon.svg',
  };
  const handleInput = (e) => {
    value = e.target.value;
    dispatch('onHandleInput', e);
  };
  export let handleChange = (e) => {
    dispatch('onHandleChange', e);
  };
  export let keypress = (e) => {
    dispatch('onHandleKeypress', e);
  };

  export let handleFocus = (e) => {};
  export let handleBlur = (e) => {};
</script>

<div
  class="form-group mb-3 w-100 position-relative {error ? 'error' : ''} {parentClass} {iconType
    ? 'input-icon'
    : ''}  "
>
  {#if label}
    <label
      for={name}
      class="form-label {labelColor}">{label} {isRequired ? '*' : ''}</label
    >
  {/if}
  {#if iconType}
    <img
      alt=""
      class="icon-16 position-absolute"
      src={iconList[iconType]}
    />
  {/if}
  {#if maxLength && !(disabled != undefined && disabled == true) && value && value.length > 0}
    <span
      class="position-absolute"
      style="font-size: 10px;right: 0px;top: 4px;">{value.length}/{maxLength}</span
    >
  {/if}
  <input
    autocomplete={autocomplete}
    bind:this={formInput}
    name={name}
    type={type}
    value={value}
    placeholder={placeholder}
    disabled={disabled}
    maxLength={maxLength}
    on:input={handleInput}
    on:change={handleChange}
    on:keypress={keypress}
    on:focus={handleFocus}
    on:blur={handleBlur}
    class="form-control {inputStyle}"
  />
  {#if error}
    <label
      class="formError"
      for={name}>{error}</label
    >
  {/if}
</div>

<style lang="scss">
</style>
